<section class="build-list" aria-label="Faulty ECU builds" [attr.aria-busy]="faultyEcuBuildsService.isLoading()">
    <div class="list-heading"><h2>ECU build names</h2><span>{{ faultyEcuBuildsService.totalElements() | number }} names</span></div>
        <div class="table-container" infinite-scroll [scrollWindow]="false"
             [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150"
             [infiniteScrollDisabled]="!faultyEcuBuildsService.canLoadMore()"
             (scrolled)="faultyEcuBuildsService.onScroll()">
            <table>
                <thead><tr><th scope="col">ECU build</th><th scope="col" class="count-column">Pure Originals</th></tr></thead>
                <tbody>
                @for (element of faultyEcuBuildList(); track element.value) {
                    <tr [class.active]="selectedEcu() === element.value">
                        <td><button type="button" class="build-select" [attr.aria-pressed]="selectedEcu() === element.value"
                                    (click)="getFaultyPureOriginalsByFaultyEcuBuild(element.value)">
                            <span [title]="element.value">{{ element.value || '(Empty value)' }}</span><i class="bi bi-chevron-right" aria-hidden="true"></i>
                        </button></td>
                        <td class="count-column"><span class="count-badge">{{ element.count == null ? '—' : (element.count | number) }}</span></td>
                    </tr>
                } @empty {
                    @if (!faultyEcuBuildsService.isLoading() && !faultyEcuBuildsService.error()) {
                    <tr><td colspan="2" class="empty-state">No faulty ECU builds found.</td></tr>
                    }
                }
                </tbody>
            </table>
            @if (faultyEcuBuildsService.isLoading()) {
                <div class="list-state" [class.more-state]="faultyEcuBuildList().length > 0" role="status"><i class="bi bi-arrow-repeat" aria-hidden="true"></i>Loading ECU builds…</div>
            } @else if (faultyEcuBuildsService.error()) {
                <div class="list-state" [class.more-state]="faultyEcuBuildList().length > 0" role="alert"><p>{{ faultyEcuBuildsService.error() }}</p><button type="button" (click)="faultyEcuBuildsService.retry()">Retry</button></div>
            }
        </div>
</section>
